import { render } from "./Stats.vue?vue&type=template&id=e1a7398e&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=e1a7398e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e1a7398e"

export default script